import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problema from "@/components/Problema";
import Servizio from "@/components/Servizio";
import ComeFunziona from "@/components/ComeFunziona";
import Professionista from "@/components/Professionista";
import Offerta from "@/components/Offerta";
import Benefici from "@/components/Benefici";
import PerChi from "@/components/PerChi";
import Manifesto from "@/components/Manifesto";
import Faq from "@/components/Faq";
import Contatti from "@/components/Contatti";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div className="relative min-h-screen overflow-x-clip bg-[#0B132B] font-body text-slate-100">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Problema />
        <Servizio />
        <ComeFunziona />
        <Professionista />
        <Offerta />
        <Benefici />
        <PerChi />
        <Manifesto />
        <Faq />
        <Contatti />
      </main>
      <Footer />
    </div>
  );
}
